import { render, staticRenderFns } from "./DateTimeMetadataInput.vue?vue&type=template&id=d924605a&scoped=true"
import script from "./DateTimeMetadataInput.vue?vue&type=script&lang=js"
export * from "./DateTimeMetadataInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d924605a",
  null
  
)

export default component.exports